export interface InviteStateProps {
  inviteesList: string[];
  type: InviteStateType;
}

export enum InviteStateType {
  SUCCESS = 1,
  ERROR = 2
}